// extracted by mini-css-extract-plugin
export var orderDetails = "_uw-2";
export var orderImage = "_uw-1";
export var orderMeta = "_uw-3";
export var orderSummary = "_uw-0";
export var rightArrow = "_uw-4";